import PropTypes from "prop-types"
import React from "react"

const PrintRequestDescription = ({ description }) => {
  if (!description) return null
  return (
    <div className="border-b border-gray-300 py-4">
      <div className="mb-1.5 text-xxs font-bold uppercase tracking-wide">
        Request description
      </div>
      <div className="whitespace-pre-line break-words text-sm leading-relaxed">
        {description}
      </div>
    </div>
  )
}

PrintRequestDescription.propTypes = { description: PropTypes.string }

export default PrintRequestDescription
